/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Message: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M22 1H2C1.46957 1 0.960859 1.21071 0.585786 1.58579C0.210714 1.96086 0 2.46957 0 3L0 16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H7.5L12 23L16.5 18H22C22.5304 18 23.0391 17.7893 23.4142 17.4142C23.7893 17.0391 24 16.5304 24 16V3C24 2.46957 23.7893 1.96086 23.4142 1.58579C23.0391 1.21071 22.5304 1 22 1Z'
      fill='currentColor'
    />
  </React.Fragment>
)
